const FileDownloadIcon = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.207 8.37868C13.5975 8.7692 13.5975 9.40237 13.207 9.79289L9.70696 13.2929C9.31643 13.6834 8.68327 13.6834 8.29274 13.2929L4.79274 9.79289C4.40222 9.40237 4.40222 8.7692 4.79274 8.37868C5.18327 7.98815 5.81643 7.98815 6.20696 8.37868L8.99985 11.1716L11.7927 8.37868C12.1833 7.98815 12.8164 7.98815 13.207 8.37868Z"
        className="icon-fill-primary"
      />
      <rect
        x="10"
        y="12"
        width="2"
        height="8"
        rx="1"
        transform="rotate(-180 10 12)"
        className="icon-fill-primary"
      />
      <circle
        cx="9"
        cy="9"
        r="8"
        className="icon-stroke-primary"
        stroke-width="2"
      />
    </svg>
  );
};

export default FileDownloadIcon;
